import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';
import pick from 'lodash/pick';
import { claimedOfferPropertyWhitelist } from 'modules/offers/constants';
import { ClaimOfferSuccessPayload } from 'modules/offers/actions';

export const translateClaimOffer = (
  response: object,
): ClaimOfferSuccessPayload => {
  const fullResult = convertSnakeToCamelCase(response);
  return pick(fullResult, claimedOfferPropertyWhitelist);
};
